import './config/CN_LAN.js';
import React from 'react';
import ReactDOM from 'react-dom';
import './App.css';
import './m_index.css';
import MyMenu from './MyMenu';
import MainSlider from './App';
import NewsComp from './News';
import GamesComp from './Games_Swiper';
//import EventCalendar from './EventCalendarNotice';
import ContactComp from './Contact';
import FooterComp from './Footer';
import * as serviceWorker from './serviceWorker';
import {ListView,WhiteSpace} from "antd-mobile";

const siteTitle=COMPANY_NAME_LC;
document.title=siteTitle;
const imgBase=PAGE_DATA['imgBase'];
const GetMainBanner = function(){
    let ret=[],count=0;
    if(window.mainBannersData){
        let d=window.mainBannersData;
        let sortedKeyArr=[];
        for(let o in d){
            sortedKeyArr.push(o);
        }
        for(let i of sortedKeyArr){
            let k=i;
            let cd=d[k];
            if(cd){
                let pid="index_big_banner_"+count;
                let pname=cd[0],purl=cd[1],pimg=imgBase+cd[2];
                let ptt="adroll.mainslider.mobile_cn."+decodeURIComponent(pname);
                ret.push(
                    {
                        pid,
                        purl,
                        pimg,
                        ptt,
                    }
                )
                count++;
            }
        }

    }
    return ret;
}
const GetGamesSlider=function () {
    let ret=[],num=1;
    if(window.gamesBannersData){
        let d=window.gamesBannersData;
        let sortedKeyArr=[];
        for(let o in d){
            sortedKeyArr.push(o);
        }
        for(let i of sortedKeyArr){
            let k=i;
            let cd=d[k];
            if(cd){
                let pname=cd[0],href=cd[1],icon=imgBase+cd[2];
                let ptt="adroll.gamesSlider.mobile_cn."+decodeURIComponent(pname);
                ret.push(
                    {
                        pname,
                        num,
                        href,
                        icon,
                        ptt,
                    }
                )
                num++;
            }
        }
    }
    return ret;
}
const GetNewsListDataFromShtml = function(){
    let lanDataKey=(CUR_LAN==='en'?'amsData33917':'amsData33721');
    let data=window[lanDataKey].slice(0,3);
    let NewsData=window[lanDataKey].slice(0,3);;//title date url typeid
    let newsBase=PAGE_DATA['newsBase'];
    let NewsDataBlob={};
    let NewsSectionIds=["NewsSection0"];
    NewsDataBlob['NewsSection0']='News.';
    let NewsRowIds=[];
    NewsRowIds[0]=[];
    for(let i = 0; i < data.length; i++){
        let rowName = `Row0-${i}`;
        NewsRowIds[0].push(rowName);
        NewsDataBlob[rowName]=rowName;
    }
    return {
        data,
        newsBase,
        NewsDataBlob,
        NewsSectionIds,
        NewsRowIds
    }
}
let newsData=GetNewsListDataFromShtml();
class ALL extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            'orientation':'portrait'
        };
    }
    componentDidMount() {
        let that = this;

        (function () {
            var supportOrientation = (typeof window.orientation === 'number' &&
                typeof window.onorientationchange === 'object');
            var init = function () {
                var htmlNode = document.body.parentNode,
                    orientation;
                var updateOrientation = function () {
                    if (supportOrientation) {
                        orientation = window.orientation;
                        switch (orientation) {
                            case 90:
                            case -90:
                                orientation = 'landscape';
                                break;
                            default:
                                orientation = 'portrait';
                                break;
                        }
                    } else {

                        let iwidth = window.innerWidth;
                        let iheight = window.innerHeight;
                        if (typeof iwidth != 'number') {  //如果类型不为number,表示该浏览器不支持innerWidth属性

                            if (document.compatMode == 'CSS1Compat') {   //CSS1Compat：判断是否为标准兼容模式。

                                iwidth = document.documentElement.clientWidth;

                                iheight = document.docuementElement.clientHeight;

                            } else { //不是标准模式,则有可能是IE6或及其以下版本(早期的浏览器对css进行解析时，并未遵守W3C标准)

                                iwidth = document.body.clientWidth;   //网页可见区域宽

                                iheight = document.body.clientHeight;   //网页可见区域高
                            }

                        }

                        orientation = (window.innerWidth > window.innerHeight) ? 'landscape' : 'portrait';
                    }
                    htmlNode.setAttribute('class', orientation);
                    setTimeout(function(){
                        //ReactDOM.findDOMNode(that).innerHTML="";
                        that.setState({
                            'orientation':orientation
                        })
                        that.forceUpdate();
                    },200);
                };
                if (supportOrientation) {
                    window.addEventListener('orientationchange', updateOrientation, false);
                } else {
//监听resize事件
                    window.addEventListener('resize', updateOrientation, false);
                }
                updateOrientation();
            };
            window.addEventListener('DOMContentLoaded', init, false);
        })();
    }
    render(){
        return (<div>
            <MyMenu menus={null} cglanto={BASE_SUBURLS[TARGET_LAN].index} title={siteTitle} />
            <MainSlider orientation={this.state.orientation} data={GetMainBanner()}/>
            {/*<EventCalendar />*/}
            <WhiteSpace size='md' />
            <GamesComp data={GetGamesSlider()}/>
            <WhiteSpace size='md' />
            <NewsComp data={newsData} moreurl={BASE_SUBURLS[CUR_LAN].news} newsdetailurl={BASE_SUBURLS[CUR_LAN].newsdetail}/>
            <WhiteSpace size='md' />
            <ContactComp/>
            <WhiteSpace size='md' />
            <FooterComp/>
        </div>);
    }
}
ReactDOM.render(
    <ALL />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
